import { Popover, PopoverContent, PopoverTemplate } from "@src/controls/popoverControl";
import { ClientError } from "@src/infrastructure/logging/index";

let defaultPopoverSettings = {
    html: true,
    trigger: 'hover focus',
    title: '',
    placement: 'auto'
};

function bindContent(popover: PopoverContent, $elem: JQuery, popoverSettings: any) {
    popoverSettings.content = ko.unwrap(popover.content);
    $elem.popover(popoverSettings);
}

function bindTemplate(popover: PopoverTemplate, $elem: JQuery, popoverSettings: any, bindingContext: KnockoutBindingContext) {
    const template = ko.unwrap(popover.template);
    const templateHtml = $(`#${template}`).html();
    const $templateHtml = $(templateHtml);

    const thePopover = $templateHtml.get(0);
    ko.cleanNode(thePopover);
    if (popover.viewModel != null) {
        const childBindingContext = bindingContext.createChildContext(popover.viewModel);
        ko.applyBindings(childBindingContext, thePopover);
    }

    popoverSettings.content = thePopover;
    $elem.popover(popoverSettings);
}

function bindPopover(element, valueAccessor, allBindings, viewModel, bindingContext) {
    const popover: Popover = valueAccessor();
    let popoverSettings: any = Object.assign({}, defaultPopoverSettings);
    popoverSettings.title = popover.title ?? defaultPopoverSettings.title;
    popoverSettings.placement = popover.placement ?? defaultPopoverSettings.placement;
    popoverSettings.trigger = popover.trigger ?? defaultPopoverSettings.trigger;
    const $elem = $(element);

    if ('content' in popover) {
        bindContent(popover, $elem, popoverSettings);
    }
    else if ('template' in popover) {
        bindTemplate(popover, $elem, popoverSettings, bindingContext);
    }
    else {
        throw new ClientError('PopoverBindingNotRecognized',
            `popover knockout binding was not passed a correct object of type Popover: ${element.outerHTML}`);
    }
}

ko.bindingHandlers.popover = {
    init: bindPopover,
    update: bindPopover
}